export default __webpack_public_path__ + "static/media/personal trainer.0f405a58.svg";